module.exports = __webpack_public_path__ + "static/media/popular-events.19289ad6.jpg";